import React, { useState, useEffect, useRef } from 'react';
import './myChallenge.style.scss';

const MyChallenge = ({ key, imageURL, videoURL, title, eventTime, eventsTotal, weeks, subtitle, about, onNavigate, id, publicFlag, onPublicPopUp }) => {

    const [showPopup, setShowPopup] = useState(false);
    const popupRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShowPopup(false);
            }
        };

        if (showPopup) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPopup]);

    return (
        <div>
            {/* My Challenge */}
            <div className="my-challenge">
                <div className="image"
                    style={{
                        backgroundImage: `url(${imageURL})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                </div>
                <div className="challenge-info">
                    <div className="title">
                        <h2 onClick={() => onNavigate(id)}>{title}</h2>
                        {
                            publicFlag ? (
                                <p
                                    onClick={() => onPublicPopUp(key)}
                                    style={{ margin: 0, fontWeight: 600, color: 'var(--coloraccent2strong)', fontSize: 'small', cursor: 'pointer', marginRight: '4px' }}
                                >public</p>
                            ) : (
                                <p
                                    onClick={() => onPublicPopUp(key)}
                                    style={{ margin: 0, fontWeight: 600, color: 'var(--fontgrey)', fontSize: 'small', cursor: 'pointer', marginRight: '4px' }}
                                >private</p>
                            )
                        }
                    </div>
                    <div className="text">
                        <div style={{ display: 'flex' }}>
                            <p style={{ fontWeight: "bold", width: "fit-content" }}>
                                {eventTime} · {eventsTotal} events · {weeks} weeks
                            </p>
                            {
                                videoURL !== "" ? (
                                    <p
                                        style={{ color: '#0000EE', fontWeight: 600 }}
                                        onClick={() => window.open(videoURL, '_blank')}
                                    >video</p>
                                ) : null
                            }
                        </div>
                        <div className="subtitle clampedd">
                            {
                                about.split('\n\n').map((paragraph, index) => (
                                    <React.Fragment key={index}>
                                        <p>{paragraph}</p>
                                    </React.Fragment>
                                ))
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyChallenge;